import {
  SxProps,
  Theme,
  Tooltip,
  Typography,
  TypographyPropsColorOverrides,
  TypographyPropsVariantOverrides,
  useTheme,
} from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import React from "react";

export type TableCellTypographyProps = {
  data: string;
  sx?: SxProps<Theme> | undefined;
  variant?: Variant;
  color?: "text.primary" | "text.secondary";
  fontWeight?: number;
};

const TableCellTypography: React.FC<TableCellTypographyProps> = (props) => {
  const { data, sx, variant, fontWeight = 400, color = "text.primary" } = props;

  return (
    <Typography
      sx={{ ...sx, maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
      color={color}
      fontWeight={fontWeight}
      variant={variant}
    >
      {data}
    </Typography>
  );
};

const TableCellLongTypography: React.FC<TableCellTypographyProps> = (props) => {
  const { data, sx, variant, fontWeight = 400, color = "text.primary" } = props;
  const theme = useTheme();
  return (
    <Typography
      sx={{
        ...sx,
        wordBreak: "break-word",
      }}
      color={color}
      fontWeight={fontWeight}
      variant={variant}
    >
      {data}
    </Typography>
  );
};

export default TableCellTypography;
export { TableCellLongTypography };
